export const whiteList = ['oaLogin','oaMsg','oaTodo','login','chatrobot','resetPassword'];
